import {
    call, put, takeLatest,
} from 'redux-saga/effects';
import {
    CREATE_DRIVER,
    GET_DRIVER,
    UPDATE_DRIVER_PASSWORD,
    CREATE_CALENDAR_USER,
    GET_CALENDAR_USER,
    UPDATE_CALENDAR_USER_PASSWORD,
    UPDATE_CALENDAR_ACCESS,
} from '../constants/transport_user.constants';
import {
    getDriverRequest,
    createDriverRequest,
    updateDriverPasswordRequest,
    getCalendarUserRequest,
    createCalendarUserRequest,
    updateCalendarUserPasswordRequest,
    updateCalendarAccessRequest,
} from '../../requests/transport_user.requests';
import {
    getDriverSuccess,
    getDriverFailure,
    createDriverSuccess,
    createDriverFailure,
    updateDriverPasswordSuccess,
    updateDriverPasswordFailure,
    getCalendarUserSuccess,
    getCalendarUserFailure,
    createCalendarUserSuccess,
    createCalendarUserFailure,
    updateCalendarUserPasswordSuccess,
    updateCalendarUserPasswordFailure,
    updateCalendarAccessFailure,
} from '../actions/transport_user.actions';
import { message_error, message_success, message_notification } from '../../../../../components/Message';

function* getDriver({ email }) {
    try {
        const { options } = yield call(getDriverRequest, email);

        yield put(getDriverSuccess(options));
    } catch (err) {
        yield put(getDriverFailure());
        message_error(err?.error || 'Failed to get driver');
    }
}

function* createDriver({ data }) {
    try {
        const { result, error, options } = yield call(createDriverRequest, data);

        if (result) {
            yield put(createDriverSuccess(options));
            message_success('Driver created successfully');
        } else {
            yield put(createDriverFailure());
            message_error(error);
        }
    } catch {
        yield put(createDriverFailure());
        message_error('Failed to create driver');
    }
}

function* updateDriverPassword({ data }) {
    try {
        yield call(updateDriverPasswordRequest, data);
        yield put(updateDriverPasswordSuccess());
        message_notification('Driver password updated successfully. Please notify the driver to manually log out of the application.');
    } catch (err) {
        yield put(updateDriverPasswordFailure());
        message_error(err?.error || 'Failed to update driver password');
    }
}

function* getCalendarUser({ email }) {
    try {
        const { options } = yield call(getCalendarUserRequest, email);

        yield put(getCalendarUserSuccess(options));
    } catch (err) {
        yield put(getCalendarUserFailure());
        message_error(err?.error || 'Failed to get calendar user');
    }
}

function* createCalendarUser({ data }) {
    try {
        const { result, error, options } = yield call(createCalendarUserRequest, data);

        if (result) {
            yield put(createCalendarUserSuccess(options));
            message_success('Calendar user created successfully');
        } else {
            yield put(createCalendarUserFailure());
            message_error(error);
        }
    } catch {
        yield put(createCalendarUserFailure());
        message_error('Failed to create calendar user');
    }
}

function* updateCalendarUserPassword({ data }) {
    try {
        yield call(updateCalendarUserPasswordRequest, data);
        yield put(updateCalendarUserPasswordSuccess());
        message_notification('Calendar user password updated successfully. Please notify the user to manually log out of the Calendar application.');
    } catch (err) {
        yield put(updateCalendarUserPasswordFailure());
        message_error(err?.error || 'Failed to update calendar user password');
    }
}

function* updateCalendarAccess({ data }) {
    try {
        yield call(updateCalendarAccessRequest, data);
        yield call(getCalendarUser, data);
        message_notification('Calendar user access updated successfully. Please notify the user to manually log out of the Calendar application.');
    } catch (err) {
        yield put(updateCalendarAccessFailure());
        message_error(err?.error || 'Failed to update calendar user access');
    }
}

export default function* transportUserSaga() {
    yield takeLatest(GET_DRIVER, getDriver);
    yield takeLatest(CREATE_DRIVER, createDriver);
    yield takeLatest(UPDATE_DRIVER_PASSWORD, updateDriverPassword);

    yield takeLatest(GET_CALENDAR_USER, getCalendarUser);
    yield takeLatest(CREATE_CALENDAR_USER, createCalendarUser);
    yield takeLatest(UPDATE_CALENDAR_USER_PASSWORD, updateCalendarUserPassword);
    yield takeLatest(UPDATE_CALENDAR_ACCESS, updateCalendarAccess);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/transport_user.saga.js